<div class="container-box">
    <!-- <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb> -->
    <div class="row">
        <div class="col-sm-12 col-md-6 col-md-offset-3">
            <h1>Add a user</h1>
            <div class="alert valign-children-middle" *ngIf="errorMsg.length > 0">
                <div class="alert-error" aria-label="Alert.">
                    <i aria-hidden="true" class="icon-badgealert"></i>
                </div>
                <div>
                    <h2> Error !</h2>
                    <p>{{ errorMsg }}</p>
                </div>
            </div>

            <form [formGroup]="addUser" autocomplete="off">
                <div class="form-group">
                    <label for="fname" [ngClass]="{'error-field': formErrors.firstName}" class="col-sm-12 col-md-8">First name</label>
                    <div class="col-sm-12 col-md-8 input-field">
                        <input type="text" [attr.aria-describedby]="formErrors.firstName? 'first-name-error' : null" maxlength="40" [ngClass]="{'text-error': formErrors.firstName}"
                            class="form-control" formControlName="firstName" id="fname">
                        <div id="first-name-error" *ngIf="formErrors.firstName" class="text-danger">{{ formErrors.firstName }}</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="lname" [ngClass]="{'error-field': formErrors.lastName}" class="col-sm-12 col-md-8">Last name</label>
                    <div class="col-sm-12 col-md-8 input-field">
                        <input id="text" [attr.aria-describedby]="formErrors.lastName? 'last-name-error' : null" maxlength="40" [ngClass]="{'text-error': formErrors.lastName}"
                            formControlName="lastName" class="form-control" id="lname">
                        <div id="last-name-error" *ngIf="formErrors.lastName" class="text-danger">{{ formErrors.lastName }}</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="mail" [ngClass]="{'error-field': formErrors.email}" class="col-sm-12 col-md-8">Email</label>
                    <div class="col-sm-12 col-md-8 input-field">
                        <input type="email" [attr.aria-describedby]="formErrors.email? 'email-error-field' : null" maxLength="175" [ngClass]="{'text-error': formErrors.email}"
                            formControlName="email" class="form-control" id="mail">
                        <div id="email-error-field" *ngIf="formErrors.email" class="text-danger">{{ formErrors.email }}</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="phoneNumber" [ngClass]="{'error-field': formErrors.phoneNumber}" class="col-sm-12 col-md-8">Contact number</label>
                    <div class="col-sm-12 col-md-8 input-field">
                        <input type="text" [attr.aria-describedby]="formErrors.phoneNumber? 'ph-numb-error' : null" [ngClass]="{'text-error': formErrors.phoneNumber}"
                            formControlName="phoneNumber" (keypress)='contactChange($event)' (focus)='contactFocus($event)' (blur)='contactBlur($event)'
                            maxLength="12" class="form-control" id="phoneNumber">
                        <div id="ph-numb-error" *ngIf="formErrors.phoneNumber" class="text-danger">{{ formErrors.phoneNumber }}</div>
                    </div>
                </div>

                <hr class="bottom-hr" />
                <div class="row">
                    <div class="col-sm-12 pull-right">
                        <button type="submit" [checkImpersonator]="(csrPermissionAddUserButton || addUser.invalid)" class="btn btn-secondary logInTest pull-right"
                            (click)="submit()" aria-label="Add user.">Add user</button>
                        <a class="btn btn-link btn-cart" href="javascript:void(0)" (click)="cancel()">Cancel</a>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>